import { FC } from 'react'
import { useTranslate } from 'react-admin'
import ButtonBase from '@mui/material/ButtonBase'
import Tooltip from '@mui/material/Tooltip'
import AutoFixHighIcon from '@mui/icons-material/AutoFixHigh'
import { themeColor } from '../../../layout/theme/color'

const FormatJsonPill: FC<{ onFormat: () => void }> = ({ onFormat }) => {
  const translate = useTranslate()
  return (
    <Tooltip title={translate('workflow.config.paramJsonFormat')}>
      <ButtonBase
        onClick={onFormat}
        sx={{
          'display': 'inline-flex',
          'alignItems': 'center',
          'px': 0.75,
          'py': 0.25,
          'borderRadius': '6px',
          'color': themeColor.slate40,
          'transition': 'color 120ms ease',
          '&:hover': { color: themeColor.slate60 },
        }}
      >
        <AutoFixHighIcon sx={{ fontSize: 12 }} />
      </ButtonBase>
    </Tooltip>
  )
}

export default FormatJsonPill
